<template>
    <page title="account">
        <div v-loading="loading.admin">
            <AccountForm :account="account" :afterSave="getAdmin" />
        </div>
        <el-button type="danger" size="mini" @click="logout">Logout</el-button>
    </page>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import AccountForm from './AccountForm'
import Page from '@/components/layout/Page';

export default {
    data() {
        return {
            email: '',
            details: {},
            account: {},
        };
    },
    components: {
        Page,
        AccountForm
    },
    computed: mapGetters(['admin', 'loading']),
    async mounted() {
        if (isEmpty(this.admin)) await this.getAdmin();
        const { first_name, last_name, phone_number, slack_username, email } = this.admin;
        this.details = { first_name, last_name, phone_number, slack_username };
        this.email = email;
    },
    methods: {
        ...mapActions(['getAdmin', 'setAdminDetails']),
        logout() {
            this.$store.commit('logout');
            window.location.reload();
        },
    },
    watch: {
        admin(newValue) {
            this.account = cloneDeep(newValue);
        }
    }
}
</script>
